import { ESMOverdueStockItem, ESMOverdueStocksFilterOptions } from '@/types/esmOverdueStocks';
import { apiClient } from './client';
import { watchlistApi } from './watchlistApi';

export const getESMOverdueStocksFilterOptions = async (): Promise<ESMOverdueStocksFilterOptions> => {
  try {
    const watchlistsResponse = await watchlistApi.listWatchlists();

    const watchlists = watchlistsResponse.watchlists.map(w => ({
      id: w.id,
      name: w.name,
      number_of_stocks: w.number_of_stocks || 0,
      watchlist_type: w.watchlist_type || 'default'
    }));

    return {
      stock_name: '',
      watchlists
    };
  } catch (error) {
    console.error('Error fetching ESM overdue stocks filter options:', error);
    // Return empty watchlists as fallback
    return {
      stock_name: '',
      watchlists: []
    };
  }
};

/**
 * Fetch ESM 2 overdue stocks based on filter criteria
 */
export const getESMOverdueStocks = async (filters: Record<string, unknown> = {}): Promise<ESMOverdueStockItem[]> => {
  try {
    const response = await apiClient.get('/market/esm-2-overdue-stocks', {
      params: filters
    });
    
    // Type assertion for response structure
    const responseData = response.data as { data: ESMOverdueStockItem[] };
    
    // Ensure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }
    
    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching ESM overdue stocks:', error);
    throw error;
  }
};
